import { Column, Row } from "best-common-react";
import React from "react";
import AccessCutoffOverrider from "../cutoffs/AccessCutoffOverrider";

const EventAccessAndCutoff = ({ accessOverride, setAccessOverride, cutoffOverride, setCutoffOverride, timezone }) => (
  <Row>
    <Column width={2}>
      <AccessCutoffOverrider override={accessOverride} setOverride={setAccessOverride} timezone={timezone} />
    </Column>
    <Column width={2}>
      <AccessCutoffOverrider
        override={cutoffOverride}
        setOverride={setCutoffOverride}
        timezone={timezone}
        isCutoff={true}
      />
    </Column>
  </Row>
);

export default EventAccessAndCutoff;
